<template>
  <div :style="{ height: scrollerHeight }">
    <div class="flex" :style="{ height: scrollerHeight }" v-if="changecont">
      <div class="width43 leftbg">
        <img class="logecont" src="@/assets/barsvg/logo-zh@3x.png" alt="" />
        <div class="leftcont">
          <p>{{ title }}</p>
          <p class="leftconts">
            ENTERPRISE SCIENCE AND TECHNOLOGY INNOVATION MANAGEMENT SYSTEM
          </p>
        </div>
        <div class="leftbot">
          <p>{{ author }} {{ icp_number }} {{ block_chain_number }}</p>
        </div>
      </div>
      <div class="width57">
        <div class="rightchange flex-leftwrap cursorpointer">
          <span @click="changesign()" :class="{ setClassName: classStatu }"
            >账号登录</span
          >
          <span
            class="margin-left20"
            @click="changerignt()"
            :class="{ setClassName: classStatus }"
            >验证码登录</span
          >
        </div>
        <password v-if="logingpassword"></password>
        <Verification v-if="loginrigest"></Verification>
      </div>
    </div>

    <rigest v-if="rigestcont"></rigest>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import password from "./password.vue";
import Verification from "./Verification.vue";
import rigest from "./rigest.vue";
import { apiconfig } from "@/api/login/login.api";
import VueCookie from "vue-cookie";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      logingpassword: true,
      loginrigest: false,
      rigestcont: false,
      classStatu: true,
      classStatus: false,
      scrollerHeight: "",
      changecont: true,
      title: "",
      author: "",
      icp_number: "",
      block_chain_number: "",
    };
  },
  methods: {
    // 账号密码登录
    changesign() {
      this.classStatu = true;
      this.classStatus = false;
      this.logingpassword = true;
      this.rigestcont = false;
      this.loginrigest = false;
    },
    // 验证码登录
    changerignt() {
      this.classStatu = false;
      this.classStatus = true;
      this.logingpassword = false;
      this.loginrigest = true;
      this.rigestcont = false;
    },
  },
  components: {
    password,
    Verification,
    rigest,
  },

  created() {
    this.scrollerHeight = window.innerHeight + "px";
    apiconfig({}).then((res) => {
      if (res.data.code == 200) {
        this.title = res.data.data.title;
        this.author = res.data.data.author;
        this.icp_number = res.data.data.icp_number;
        this.block_chain_number = res.data.data.block_chain_number;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("righten", (data) => {
      if (data == 111) {
        this.changecont = false;
        this.rigestcont = true;
      } else {
        this.changecont = true;
        this.rigestcont = false;
      }
    });
  },
};
</script>

<style scoped>
.leftbg {
  background: url("../../assets/barsvg/loginbg.png") no-repeat left;
  background-size: 100% 100%;
}
.logecont {
  width: 120px;
  height: 30px;
  position: relative;
  top: 50px;
  left: 60px;
}
.leftcont {
  font-family: PingFangSC-Semibold;
  font-size: 30px;
  color: #353a44;
  line-height: 30px;
  font-weight: 600;
  width: 50%;
  position: relative;
  top: 100px;
  left: 60px;
}
.leftconts {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #6a7589;
  line-height: 24px;
  font-weight: 400;
  padding-top: 10px;
}
.leftbot {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #969eac;
  line-height: 22px;
  font-weight: 400;
  width: 70%;
  margin: auto;
  position: relative;
  top: 740px;
}
.rightchange {
  width: 46%;
  margin: 300px auto 20px;
  font-family: PingFangSC-Medium;
  font-size: 24px;
  color: #969eac;
  line-height: 24px;
  font-weight: 500;
}
.setClassName {
  font-family: PingFangSC-Medium;
  font-size: 24px;
  color: #353a44;
  line-height: 24px;
  font-weight: 500;
  padding-bottom: 20px;
  border-bottom: 3px solid black;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>